import { Background } from '../components/Background';

/**
 * Temporary static holding page shown while the site is not public yet.
 */
export function ComingSoonPage() {
  return (
    <main className="coming-soon" aria-labelledby="coming-soon-message">
      <Background />
      <h1 id="coming-soon-message" className="coming-soon__message">
        Coming soon torno subito ciao
      </h1>
    </main>
  );
}
